import { base64Decode, hashCode } from "./utils.js"

/**
 * @description: 生成客户端唯一标识符
 * @return {string} 返回唯一的客户端ID
 * @author:
 */
function generateClientId() {
  // 收集客户端特征信息
  const clientInfo = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screenWidth: screen.width,
    screenHeight: screen.height,
    colorDepth: screen.colorDepth,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  }

  // 将信息转换为字符串并生成哈希
  const clientString = JSON.stringify(clientInfo)
  const hash = hashCode(clientString)

  // 使用固定的格式，不包含时间戳
  return `client_${Math.abs(hash)}`
}

/**
 * @description: 获取用户ID的通用方法
 * 优先级：accountInfo.yuuId > accountInfo.custId > localStorage.uniqueId > 生成的客户端ID
 * @return {string} 返回用户ID
 * @author:
 */
export function getUserId() {
  const { userId } = getUserIdAndLabel()
  return userId
}

/**
 * @description: 获取用户ID及埋点标签，用于 online-sales-sdk
 * 若有 yuuId 优先取 yuuId，此时 customLabel 为 "yuu"；否则取 custId，customLabel 为 "hk_711"
 * @return {{ userId: string, customLabel: string }}
 */
export function getUserIdAndLabel() {
  let userId = ""
  let customLabel = "hk_711"

  const accountInfo =
    typeof localStorage !== "undefined" && localStorage.getItem("accountInfo")
      ? base64Decode(localStorage.getItem("accountInfo"))
      : ""

  if (accountInfo && typeof accountInfo === "object") {
    if (accountInfo.yuuId) {
      userId = accountInfo.yuuId
      customLabel = "yuu"
    } else if (accountInfo.custId) {
      userId = accountInfo.custId
    }
  }

  if (!userId) {
    userId = typeof localStorage !== "undefined" ? localStorage.getItem("uniqueId") : null
    if (!userId) {
      userId = generateClientId()
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("uniqueId", userId)
      }
    }
  }

  return { userId, customLabel }
}

/**
 * 埋点 / online-sales-sdk 使用，字段名与 SDK 约定一致
 * @return {{ userId: string, customLabel1: string }}
 */
export function getUserTrackingInfo() {
  const { userId, customLabel } = getUserIdAndLabel()
  return { userId, customLabel1: customLabel }
}
